import { render } from "./Logo.vue?vue&type=template&id=44a91dbc"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"

import "./Logo.vue?vue&type=style&index=0&id=44a91dbc&lang=scss"
script.render = render

export default script